import { ApiKeys } from '@app/constants/api-keys'
import { IOrganizationStatus } from '@app/interfaces/organization/organization-status'
import { resolveTParams } from '@app/utils/resolve-params/resolve-params'
import localforage from 'localforage'
import { emptyOrganizationApi } from '.'
import { IRtkResponse } from '../../types'

export const organizationStatusApi = emptyOrganizationApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (build) => ({
    getOrganizationStatuses: build.query<
      IRtkResponse<IOrganizationStatus[]>,
      URLSearchParams | string
    >({
      query: (args = '') => ({
        url: 'dictionary/api/v1/organization-status',
        method: 'get',
        params: {
          ...resolveTParams(args),
        },
      }),
      transformResponse: (response: IOrganizationStatus[], meta) => {
        return { response, meta }
      },
      providesTags: (data) =>
        data
          ? [
              ...data.response.map(({ id }) => ({
                type: ApiKeys.organizationsStatus,
                id,
              })),
              { type: ApiKeys.organizationsStatus, id: 'LIST' },
            ]
          : [{ type: ApiKeys.organizationsStatus, id: 'LIST' }],
      async onQueryStarted(args, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          localforage.setItem(ApiKeys.organizationsStatus, data?.response)
        } catch (e) {
          console.error(e)
        }
      },
    }),
    getOrganizationStatus: build.query<IOrganizationStatus, number>({
      query: (id) => ({
        url: `dictionary/api/v1/organization-status/${id}`,
        method: 'get',
      }),
      providesTags: (result, error, id) => [
        { type: ApiKeys.organizationsStatus, id },
      ],
    }),
  }),
})

export const {
  useGetOrganizationStatusQuery,
  useGetOrganizationStatusesQuery,
} = organizationStatusApi
